export enum PageSize {
    A4 = "A4",
    A3 = "A3",
    A2 = "A2",
    A1 = "A1",
    A0 = "A0",
    Tabloid = "Tabloid",
    Letter = "Letter",
    Legal = "Legal"
}